export default __webpack_public_path__ + "static/media/ff-background.7a7e6cc1.jpg";